module.exports = __webpack_public_path__ + "img/header-weddingRingstrisets@2x.35a86b9.jpg";